import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ContenedorComponent } from '../contenedor/contenedor.component';
import { authGuardSubmodule } from '../../auth/auth.guard';
import { EstadosFinancierosComponent } from '../seguimiento-presupuestal/estados-financieros/estados-financieros.component';
import { RazonesFinancierasComponent } from './razones-financieras/razones-financieras.component';
import { AnalisisSegmentoComponent } from './analisis-segmento/analisis-segmento.component';
import { AnalisisSucursalesComponent } from './analisis-sucursales/analisis-sucursales.component';
import { CatalogoCuentasComponent } from './catalogo-cuentas/catalogo-cuentas.component';

const routes: Routes = [
    {
      path: 'app/seguimiento-presupuestal',
      component: ContenedorComponent,
      children: [
        {path: 'catalogo-cuentas', component: CatalogoCuentasComponent, canActivate: [authGuardSubmodule]},
        {path: 'estados-financieros', component: EstadosFinancierosComponent, canActivate: [authGuardSubmodule]},
        {path: 'razones-financieras', component: RazonesFinancierasComponent, canActivate: [authGuardSubmodule]},
        {path: 'analisis-segmento', component: AnalisisSegmentoComponent, canActivate: [authGuardSubmodule]},
        {path: 'analisis-sucursales', component: AnalisisSucursalesComponent, canActivate: [authGuardSubmodule]},
      ],
    }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SeguimientoPresupuestalRoutingModule { }
